/**
 * Sync subscriber agreement notification from status api responses
 */
export const syncTosNotifyFromStatus = (responseData, setAuth) => {
  if (responseData?.tos_notify) {
    setAuth((prev) => (prev?.tos_notify ? prev : { ...prev, tos_notify: true }));
  }
};
